import { Platform } from "react-native";
import { MMKV } from "react-native-mmkv";

type Params = {
  id: string;
  booleanKeys: string[];
  numberKeys: string[];
  stringKeys: string[];
};

export const buildStorage = <Keys extends Omit<Params, "id">>({
  id,
  booleanKeys,
  stringKeys,
  numberKeys: _,
}: Params) => {
  const storage = new MMKV(Platform.OS === "web" ? undefined : { id });

  return {
    clear: () => storage.clearAll(),
    delete: (key: string) => storage.delete(`${id}:${key}`),
    set: <T extends (Keys["booleanKeys"] | Keys["stringKeys"] | Keys["numberKeys"])[number]>(
      key: T,
      value: T extends Keys["booleanKeys"][number]
        ? boolean
        : T extends Keys["stringKeys"][number]
          ? string
          : T extends Keys["numberKeys"][number]
            ? number
            : never,
    ) => storage.set(`${id}:${key}`, value),
    get: <T extends (Keys["booleanKeys"] | Keys["stringKeys"] | Keys["numberKeys"])[number]>(
      key: T,
    ) => {
      if (booleanKeys.includes(key)) {
        return storage.getBoolean(`${id}:${key}`) as T extends Keys["booleanKeys"][number]
          ? boolean
          : never;
      }
      if (stringKeys.includes(key)) {
        return storage.getString(`${id}:${key}`) as T extends Keys["stringKeys"][number]
          ? string
          : never;
      }

      return storage.getNumber(`${id}:${key}`) as T extends Keys["numberKeys"][number]
        ? number
        : never;
    },
  };
};
